import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { DeleteToken } from '../../auth/Auth';
import Loader from '../Loader';
import serverClient from '../../api/ServerClient';
import { useLanguage } from '../../context/LanguageContext';

function DeleteAccountModal({ id, onReturnFunc, setErrorForAccountDelete }) {
    const navigate = useNavigate();
    const { t } = useLanguage();
    const [, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        try {
            setLoading(true);
            await serverClient.delete(`/api/user/account/${id}`);
            onReturnFunc(1);
        } catch (e) {
            if (e.response?.status === 400) {
                setErrorForAccountDelete(e.response?.data.message);
            }
            if (e.response?.status === 401) {
                DeleteToken();
                setError(t('userNotAuthorized'));
                navigate('/login');
            } else {
                setError(t('somethingWentWrong'));
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Loader loading={loading} />

            <div className="modal error-modal fade" id="deleteAccount" tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="error-img">
                                <img
                                    className="img-fluid"
                                    src={'/assets/images/svg/delete.svg'}
                                    alt="delete"
                                />
                            </div>
                            <div className="alert alert-warning small">
                                <strong>{t('beforeYouDelete')}</strong>
                                <ul className="mt-2 mb-0">
                                    <li>{t('accountNoLongerAppear')}</li>
                                    <li>{t('pastTransactionsUnchanged')}</li>
                                    <li>{t('accountBalanceMustBeZero')}</li>
                                </ul>
                            </div>

                            <h3>{t('areYouSure')}</h3>
                            <Link
                                to="#"
                                className="btn theme-btn successfully w-100"
                                data-bs-dismiss="modal"
                                onClick={(e) => {
                                    e.target.blur();
                                    const modalElement = document.getElementById('deleteAccount');
                                    modalElement.addEventListener(
                                        'hidden.bs.modal',
                                        () => {
                                            handleDelete();
                                        },
                                        { once: true }
                                    );
                                }}
                            >
                                {t('confirmDelete')}
                            </Link>
                        </div>
                        <button type="button" className="btn close-btn" data-bs-dismiss="modal">
                            <i className="icon" data-feather="x"></i>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DeleteAccountModal;
